import React, { Component } from "react";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";
import CircularProgress from "@material-ui/core/CircularProgress";

import EditableMinistryReportDetails from "./edit_report";
// import { MinistryReportPDF, MinistryReportEmailPDF } from "../components/exportPDF.js";
import { NotificationManager, NotificationContainer } from 'react-notifications';
const changeFloat = require('../service/excelService.js').changeFloat;

const animatedComponents = makeAnimated();

const backend = require('../../config.js').backend;


class Ministry_Donations_Report extends Component {

    constructor(props) {
        super(props);

        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);

        this.state = {

            startDate: new Date(),
            endDate: new Date(),
            errors: {},
            checked: false,
            isButtonDisabled: false,
            showPopup: false,
            edit: '',
            desigDropDown: {},
            staffId: sessionStorage.getItem('id_e'),
            staffName: sessionStorage.getItem('name'),
            staffEmail: sessionStorage.getItem('email'),
            redirectLogout: false

            // desigIds:[52493, 52517, 57034, 67890, 52517],
            // SP, Ngee Ann Poly Fund, 20's - 30's Ministry, NAV TECH MINISTRY, NP-SIM          
        }
    }


    componentDidMount() {

        this.getAllDesignames()
            .then((desigs) => {
                this.setState({ allDesigs: desigs });
                this.getDropdownList();
            })

    }

    getAllDesignames = () => {

        var that = this;

        return new Promise(function (resolve, reject) {

            fetch(backend + `api/v1/gift/alldesignames`, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else {
                        resolve(data);
                    }
                })
                .catch((err) => {
                    reject(err)
                })

        })

    }


    getDropdownList = _ => {
        const { allDesigs } = this.state;
        var desigs = [];


        for (var desigId of Object.keys(allDesigs)) {

            var desig = {
                value: desigId,
                label: allDesigs[desigId]
            }

            desigs.push(desig)
        }

        desigs.sort((a, b) => (a.label > b.label) ? 1 : -1);

        return this.setState({ desigDropDown: desigs });


    }

    togglePopup = _ => {
        this.setState({ showPopup: !this.state.showPopup });
    }


    handleStartDateChange(date) {

        date = moment(date).format('YYYY-MM-DD');

        this.setState({
            startDate: date
        });

    }

    handleEndDateChange(date) {

        date = moment(date).format('YYYY-MM-DD');

        this.setState({
            endDate: date
        });

    }

    inputValid = () => {
        let { startDate } = this.state;
        let { endDate } = this.state;
        var { desigIds } = this.state;

        startDate = moment(startDate).format('YYYY-MM-DD');
        endDate = moment(endDate).format('YYYY-MM-DD');

        let today = new Date()
        let errors = {};

        if (startDate > endDate || startDate > today) {

            errors['date'] = 'Please choose correct dates!';
            this.setState({ errors: errors });
            this.setState({ isButtonDisabled: false })
            return false;

        }
        else if (!desigIds || desigIds.length === 0) {
            errors['desigs'] = 'Please choose at least one ministry!';
            this.setState({ errors: errors });
            this.setState({ isButtonDisabled: false })
            return false;
        }
        else {
            errors = {};
            this.setState({ errors: errors });
            return true;
        }

    }

    editReport = (desigId) => {
        this.togglePopup();
        this.setState({ edit: desigId })
    }

    addToAdditionalRows = (desigId, additionalRows) => {
        //console.log('addToAdditionalRows', desigId, additionalRows);

        var { reports } = this.state;
        var report = reports[desigId];

        report['additionalRows'] = additionalRows;
        reports[desigId] = report;

        this.setState({ reports: reports });

    }


    renderReport = (report, desigId) => {

        let giftList = report.giftList;
        const { isButtonDisabled } = this.state;
        var DesigName;
        console.log(report, desigId)

        if (!giftList.length) { // If no gift returned, get desig name 

            report['donationTotal'] = 0;
            var { allDesigs } = this.state;

            if (allDesigs) { // If already get the desig details
                DesigName = allDesigs[desigId]
            }
            else {
                this.getAllDesignames()
                    .then((allDesigs) => {
                        this.setState({ allDesigs: allDesigs });
                        DesigName = allDesigs[desigId]
                    })
            }
            console.log(DesigName);

        }
        else {

            DesigName = giftList[0].DesigName;
            report['donationTotal'] = giftList.reduce((totalAmount, gift) => changeFloat(totalAmount) + changeFloat(gift.TenderedAmount), 0)
            console.log(DesigName);
        }
        return (
            <tr key={desigId}>
                <td>{DesigName}</td>
                <td>

                    {(isButtonDisabled) ?
                        <button type="button" className="btn btn-edit btn-primary submit" onClick={() => this.editReport(desigId)} disabled>Edit</button>
                        :
                        <button type="button" className="btn btn-edit btn-primary submit" onClick={() => this.editReport(desigId)}>Edit</button>
                    }


                    {(this.state.edit === desigId && this.state.showPopup) ?
                        <EditableMinistryReportDetails
                            report={report}
                            closePopup={this.togglePopup.bind(this)}
                            desigName={DesigName}
                            desigId={desigId}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            addToAdditionalRows={this.addToAdditionalRows}
                        />
                        : null
                    }
                </td>
                {(report.pdf === 'OK') ?
                    <td style={{ color: 'green' }}>PDF Generated</td>
                    :
                    <td>Draft</td>
                }
            </tr>
        )

    }


    renderReports = () => {

        const { reports } = this.state;
        const { isButtonDisabled } = this.state;
        let checked = this.state.checked;
        if (checked) {

            if (reports && Object.keys(reports).length) {
                return (
                    <div>

                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th className='desigName'>Designation Name</th>
                                    <th className='action'>Actions</th>
                                    <th className=''>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {Object.keys(reports).map((desigId, i) => (
                                    this.renderReport(reports[desigId], desigId)
                                ))}
                            </tbody>

                        </table>

                        <div className="check-button">

                            {(isButtonDisabled) ?
                                <button type="button" className="btn btn-primary submit" onClick={() => this.generatePDFFiles()} disabled>Submit For Approval</button>
                                :
                                <button type="button" className="btn btn-primary submit" onClick={() => this.generatePDFFiles()} >Submit For Approval</button>
                            }


                        </div>

                    </div>

                )
            }

            else if (reports && (Object.keys(reports).length === 0)) {
                return (<h3>No data returned</h3>)
            }

            else {
                return (
                    <div style={{display:"flex", alignItems: "center", justifyContent: "center"}}>
                      <h4 className='title'>Loading... This may take a while... </h4>
                      <CircularProgress/>
                    </div>)
            }

        }



    }

    getOneReportData = (startDate, endDate, desigId) => {

        var that = this;

        // Call API to get reports
        return new Promise(function (resolve, reject) {

            var url = `api/v1/ministrydonationsreport/` + desigId + `?start=` + startDate + `&end=` + endDate;

            fetch(backend + url, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (data.status === 500) {
                        NotificationManager.error(`Couldn't get donations data for ` + desigId + `, Error: ` + data.message);
                        reject(data)
                    }
                    else {
                        resolve(data);
                    }


                })
                .catch((err) => {
                    // console.log('getFundsTranfserReport error', err);
                    reject(err)
                })

        })

    }


    getReportsData = (startDate, endDate) => {

        var { desigIds } = this.state;
        var reports = {};


        let reportPromises = desigIds.map(
            desigId =>

                this.getOneReportData(startDate, endDate, desigId)
                    .then(data => {
                        if (data) {
                            reports[desigId] = data
                        }
                    })
                    .catch(err => {
                        reports[desigId] = {}

                    })

        );


        Promise.all(reportPromises).then(() => {
            // now the Upload of all Data should start
            this.setState({ isButtonDisabled: false });
            this.setState({ reports: reports });
        });



    }

    generateReports = () => {

        var { startDate } = this.state;
        var { endDate } = this.state;

        endDate = moment(endDate).format('YYYY-MM-DD');
        startDate = moment(startDate).format('YYYY-MM-DD');

        this.setState({ isButtonDisabled: true });

        if (this.inputValid()) {

            this.setState({ checked: true });
            this.getReportsData(startDate, endDate)

        }

    }


    generateOnePDFFile = desigId => {

        const { reports } = this.state;
        const { allDesigs } = this.state;
        var report = reports[desigId];
        // console.log(desigId);
        // console.log(report);

        var { startDate } = this.state;
        var { endDate } = this.state;
        var that = this;
        var { staffId } = this.state;
        var { staffName } = this.state;
        var { staffEmail } = this.state;

        let data = {
            desigId: desigId,
            start: moment(startDate).format('YYYY-MM-DD'),
            end: moment(endDate).format('YYYY-MM-DD'),
            desigName: allDesigs[desigId],
            creatorName: staffName,
            creatorEmail: staffEmail
        }

        if (report.additionalRows) data['additionalRows'] = report.additionalRows;
        else data['additionalRows'] = [];

        return new Promise(function (resolve, reject) {

            fetch(backend + `api/v1/ministrydonationsreport/pdf/` + staffId + '/' + desigId, {
                method: 'POST',
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'report': data })
            })
                .then(response => response.json())
                .then(data => {
                    // console.log(data)
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (data.status === 500) {
                        NotificationManager.error(`Couldn't generate report for ` + desigId + `, Error: ` + data.message);
                        reject(data.message)
                    }
                    else {
                        report['pdf'] = data;
                        reports[desigId] = report;
                        that.setState({ reports: reports })
                        resolve(data);
                    }

                })
                .catch(err => {
                    reject(err)
                })

        })

    }

    checkAllTrue = array => {
        return array.every(element => element === 'OK');
    }

    generatePDFFiles = _ => {

        const { reports } = this.state;
        var fetch_PdfFiles = [];
        const desigIds = Object.keys(reports);

        this.setState({ isButtonDisabled: true })

        desigIds.forEach((desigId) => {
            fetch_PdfFiles.push(this.generateOnePDFFile(desigId))
        });

        Promise.all(fetch_PdfFiles).then((fetch_results) => {
            // console.log(fetch_results)
            if (this.checkAllTrue(fetch_results)) {
                NotificationManager.success('All PDF files have generated');
                this.setState({ isButtonDisabled: false })
            }
        })
            .catch(error => {
                // console.log(error);
                this.setState({ isButtonDisabled: false })
            });

    }

    handleDesigsChange = (m) => {

        if (m) {
            var desigIds = m.map(a => a.value);
            this.setState({ desigIds: desigIds });
        }

    }


    render() {

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        let report_list = this.renderReports();
        const { desigDropDown } = this.state;

        let content = (
            <div className="generate-ministry-donations-report">

                <h3 className="title">Generate Ministry Donations Report</h3>

                <div className="form-set row">
                    <form className="form-horizontal">
                        <div className="form-sets col-sm-12">
                            <fieldset>
                                <div className="fieldset">

                                    <div className='input-ministries'>
                                        <label className='col-lg-3 control-lebel'>MINISTRIES</label>
                                        <div className='dropdown'>
                                            <Select
                                                closeMenuOnSelect={false}
                                                components={animatedComponents}
                                                isMulti
                                                options={desigDropDown}
                                                onChange={this.handleDesigsChange}
                                            />
                                        </div>
                                        <span className="error">{this.state.errors["desigs"]}</span>
                                    </div>

                                    <div className='input-dates'>
                                        <div className="input-startdate">
                                            <label className="col-lg-3 control-lebel"> START DATE</label>

                                            <div className='datepicker'>
                                                <DatePicker
                                                    selected={(this.state.startDate === '') ? new Date() : new Date(this.state.startDate)}
                                                    onChange={this.handleStartDateChange}
                                                    dateFormat='dd-MM-yyyy'
                                                />
                                                <div className="error">
                                                    <span>{this.state.errors["date"]}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="input-enddate">
                                            <div className='float-right'>
                                                <label> END DATE</label>
                                                <div className='datepicker datepicker-right'>
                                                    <DatePicker
                                                        selected={(this.state.endDate === '') ? new Date() : new Date(this.state.endDate)}
                                                        onChange={this.handleEndDateChange}
                                                        dateFormat='dd-MM-yyyy'
                                                    />
                                                    <div className="error">
                                                        <span>{this.state.errors["date"]}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-4 check-button">
                                        <button type="button" className="btn btn-primary submit" disabled={this.state.isButtonDisabled} onClick={this.generateReports}>Generate</button>
                                    </div>

                                </div>
                            </fieldset>
                        </div>
                    </form>
                </div>

                <div className="report-table">
                    {report_list}
                </div>
                <NotificationContainer />


            </div>
        )

        return (content)
    }


}

export default Ministry_Donations_Report;
